import Header from "../../../components/layouts/header";
import Sidebar from "../../../components/layouts/sidebar";
import { APIRoutes } from "../../../utility/app-routes";
import { MasterCommonRecordPage } from "../../../components/common/common-master-record/master-common-record-page";

const Source: React.FC = () => {
	// Table Pagination

	return (
		<div className="page-inner">
			<>
				<MasterCommonRecordPage
					addUpdateApiUrl={APIRoutes.addUpdateSource}
					deleteApiUrl={APIRoutes.deleteSource}
					title="Source"
					getAllRecordApiUrl={APIRoutes.getAllSources}
				/>
			</>
		</div>
	);
};
export default Source;
